import AlarmSideBar from './component'

export default AlarmSideBar
